import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();
const settlingUserIds = new Set<number>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function subscribeParentPortalBalanceSettling(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isParentPortalBalanceSettling(userId: number) {
  return settlingUserIds.has(userId);
}

/** The ledger posts after the payment is accepted. Keep the balance card updating until the follow-up refetch finishes. */
export function markParentPortalBalanceSettling(userId: number) {
  if (!Number.isInteger(userId) || userId <= 0) return;
  if (settlingUserIds.has(userId)) return;
  settlingUserIds.add(userId);
  emit();
}

export function clearParentPortalBalanceSettling(userId: number) {
  if (!settlingUserIds.delete(userId)) return;
  emit();
}

export function useParentPortalBalanceSettling(userId: number) {
  return useSyncExternalStore(
    subscribeParentPortalBalanceSettling,
    () => isParentPortalBalanceSettling(userId),
    () => false,
  );
}
